export default __webpack_public_path__ + "static/media/Documenttation_page2.55b0ca7c.svg";